const VideoList = () => import('./videolist.vue')
const VideoDetail = () => import('./videodetail.vue')
const VideoShowOrCancel = () => import('./videoShowOrCancel.vue')

export {
  VideoList,
  VideoShowOrCancel,
  VideoDetail
}



// WEBPACK FOOTER //
// ./src/pages/videomeeting/index.js